/**
 * @license
 * @copyright Copyright Motili Inc., 2021 All Rights Reserved
 */

import { ReactElement } from 'react';
import Select from 'react-select';
import { styled } from 'styled-components';
import { stateOptions } from '../common/utils';
import { CompanyInfo } from '../common/types';

interface StateDropdownProps {
    companyInfo: CompanyInfo;
    addressType: 'billingAddress' | 'companyAddress';
    handleCompanyInfoOnChange: (info: any) => void;
}

export default function StateDropdown({
    companyInfo,
    addressType,
    handleCompanyInfoOnChange,
}: StateDropdownProps): ReactElement {
    const defaultDropDownValue = {
        value: companyInfo[addressType].state,
        label: companyInfo[addressType].state,
    };

    const setBillingAndCompanyStateValue = (value: string) => {
        handleCompanyInfoOnChange({
            companyAddress: {
                ...companyInfo.companyAddress,
                state: value,
            },
            billingAddress: {
                ...companyInfo.billingAddress,
                state: value,
            },
        });
    };

    const handleStateDropdownChange = (data: any) => {
        if (companyInfo.useCompanyAddressAsBilling) {
            setBillingAndCompanyStateValue(data.value);
        } else {
            handleCompanyInfoOnChange({
                ...companyInfo,
                [addressType]: {
                    ...companyInfo[addressType],
                    state: data.value,
                },
            });
        }
    };

    return (
        <StyledSelect
            name='state'
            defaultValue={
                defaultDropDownValue.value ? defaultDropDownValue : null
            }
            onChange={handleStateDropdownChange}
            placeholder='State'
            options={stateOptions}
        />
    );
}

const StyledSelect = styled(Select)`
    margin: 10px 0 0;
`;
